import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { BRAND } from "@/lib/site";
import QuoteForm from "@/components/QuoteForm";

export default function GetInTouchSection() {
  return (
    <section className="bg-slate-50 py-20 md:py-24" data-testid="get-in-touch-section">
      <div className="fg-container grid gap-8 md:grid-cols-12">
        {/* Left dark panel */}
        <div className="md:col-span-5">
          <div className="h-full rounded-2xl bg-slate-900 p-8 text-white md:p-10">
            <h2 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl">
              Get In <span className="text-blue-400">Touch</span>
            </h2>
            <p className="mt-5 text-base leading-relaxed text-slate-300">
              We're here to help with all your plumbing and maintenance needs —
              big or small. Whether you need an emergency repair, a quick quote,
              or expert advice, our friendly team is ready to assist.
            </p>

            <div className="mt-8 rounded-xl border border-white/10 bg-white/[0.04] p-6">
              <div className="font-display text-lg font-bold">Contact Details</div>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="flex items-center gap-3">
                  <MapPin className="h-4 w-4 text-blue-400" />
                  All of Sydney
                </li>
                <li>
                  <a
                    href={BRAND.phoneTel}
                    className="flex items-center gap-3 transition-colors hover:text-blue-300"
                    data-testid="getintouch-phone-link"
                  >
                    <Phone className="h-4 w-4 text-blue-400" />
                    <span className="font-bold">{BRAND.phone}</span>
                  </a>
                </li>
                <li>
                  <a
                    href={BRAND.emailHref}
                    className="flex items-center gap-3 transition-colors hover:text-blue-300"
                    data-testid="getintouch-email-link"
                  >
                    <Mail className="h-4 w-4 text-blue-400" />
                    {BRAND.email}
                  </a>
                </li>
              </ul>
            </div>

            <div className="mt-5 rounded-xl border border-white/10 bg-white/[0.04] p-6">
              <div className="font-display text-lg font-bold">Opening Hours</div>
              <ul className="mt-4 space-y-3 text-sm">
                <li className="flex items-center gap-3">
                  <Clock className="h-4 w-4 text-blue-400" />
                  <span>
                    Monday – Sunday<br />
                    <span className="font-bold">24 Hours, 7 Days a Week</span>
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <Clock className="h-4 w-4 text-blue-400" />
                  <span>
                    Emergency Contact<br />
                    <span className="font-bold">24/7</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Right form */}
        <div className="md:col-span-7">
          <div className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm md:p-10">
            <div className="text-center">
              <h2 className="font-display text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl">
                Request a Quote
              </h2>
              <p className="mx-auto mt-3 max-w-md text-base text-slate-600">
                Tell us about your plumbing issue or upcoming project, and we'll
                get back to you with a free, no-obligation quote.
              </p>
            </div>
            <div className="mt-7">
              <QuoteForm idPrefix="getintouch" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
